type SpecTireSizeType = {
    size: string;
    compounds: string[];
};

type SpecTirePatternType = {
    name: string;
    sizes: SpecTireSizeType[];
};

type SpecTireBrandType = {
    name: string;
    patterns: SpecTirePatternType[];
};

type SpecTireInputType = {
    brand?: string;
    pattern?: string;
    size?: string;
};

const specTires: SpecTireInputType[] = window.specTires ?? [];
const brands: SpecTireBrandType[] = window.brands;

/**
 * 賞典タイヤのカスケードセレクト.
 *
 * @returns {void}
 */
const cascadeSelectSpecTire = (): void => {
    document
        .querySelectorAll<HTMLElement>(".js-cascade-select-spec-tire")
        .forEach((table, index) => {
            setupSpecTireCascade(table, index);
        });
};

/**
 * セレクトボックスをリセットする.
 *
 * @param   {HTMLSelectElement} el
 * @param   {string} placeholder
 * @returns {void}
 */
const resetSelect = (el: HTMLSelectElement, placeholder = "-") => {
    el.innerHTML = `<option value="">${placeholder}</option>`;
    el.disabled = true;
};

/**
 * 指定された値でセレクトボックスの option を埋める.
 *
 * @param   {HTMLSelectElement} el
 * @param   {string[]} values
 * @param   {string|undefined} selected
 * @returns {void}
 */
const fillSelect = (
    el: HTMLSelectElement,
    values: string[],
    selected?: string
) => {
    resetSelect(el);
    values.forEach((value) => {
        const opt = document.createElement("option");
        opt.value = value;
        opt.textContent = value;
        if (selected === value) {
            opt.selected = true;
        }
        el.appendChild(opt);
    });
    el.disabled = false;
};

/**
 * カスケードセレクト.
 *
 * @param container
 * @param index
 */
const setupSpecTireCascade = (container: HTMLElement, index: number) => {
    const brandSelect = container.querySelector<HTMLSelectElement>(
        `.js-cascade-select-spec-tire-${index}-brand`
    );
    const patternSelect = container.querySelector<HTMLSelectElement>(
        `.js-cascade-select-spec-tire-${index}-pattern`
    );
    const sizeSelect = container.querySelector<HTMLSelectElement>(
        `.js-cascade-select-spec-tire-${index}-size`
    );

    if (!brandSelect || !patternSelect || !sizeSelect) {
        return;
    }

    resetSelect(patternSelect);
    resetSelect(sizeSelect);

    // 初期ブランド選択肢
    fillSelect(
        brandSelect,
        brands.map((b) => b.name),
        specTires[index]?.brand
    );

    // brand → pattern
    brandSelect.addEventListener("change", () => {
        const brand = brands.find((b) => b.name === brandSelect.value);
        resetSelect(sizeSelect);

        if (!brand) {
            resetSelect(patternSelect);
            return;
        }

        fillSelect(
            patternSelect,
            brand.patterns.map((p) => p.name),
            specTires[index]?.pattern
        );
    });

    // pattern → size
    patternSelect.addEventListener("change", () => {
        const brand = brands.find((b) => b.name === brandSelect.value);
        const pattern = brand?.patterns.find(
            (p) => p.name === patternSelect.value
        );

        if (!pattern) {
            resetSelect(sizeSelect);
            return;
        }

        fillSelect(
            sizeSelect,
            pattern.sizes.map((s) => s.size),
            specTires[index]?.size
        );
    });

    // 復元（brand が入っている場合）
    if (specTires[index]?.brand) {
        brandSelect.dispatchEvent(new Event("change"));
        if (specTires[index]?.pattern) {
            patternSelect.dispatchEvent(new Event("change"));
        }
    }
};

export default cascadeSelectSpecTire;
